import styled from 'styled-components';

export const CreditCardWrapper = styled.div((props) => ({
  justifyContent: 'self-start',
  width: '100%',

  [`@media${props.theme.devices.laptop}`]: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const CreditCardContent = styled.div((props) => ({
  img: { maxWidth: '350px' },
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  alignItems: 'center',
  [`@media${props.theme.devices.laptop}`]: {
    display: 'flex',
    flexDirection: 'column',
  },
}));
